import { ActionButtonVariants } from 'components/action-button';

export default {
  buttonVariant: ActionButtonVariants.OUTLINE,
  hasStartIcon: true,
  showNumItems: true,
  isSquare: false,
};
